import { Button, Input, Tabs, notification } from "antd";
import { DeleteOutlined, PlusOutlined } from "@ant-design/icons";
import { CustomModal } from "../common/CustomModal";
import React from "react";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import { listAllDropDownCourse } from "../../Graphs/Course/listAllDropDownCourse";
import { AssignGroupCourse } from "../../Graphs/CorporateGroups/AssignCourse";
import { CustomSelect } from "../common/CustomSelect";

const { TabPane } = Tabs;

export class AssignCourse extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: false,
      courses: [],
      selectedCourses: [{ course: null, maxUsers: "" }],
    };
  }

  async componentDidMount() {
    await this.fetchCourses();
  }

  fetchCourses = async () => {
    try {
      const { authToken } = this.props;
      const skip = 0;
      const limit = 50;
      const response = await listAllDropDownCourse(authToken, skip, limit);
      this.setState({ courses: response.data || [] });
    } catch (error) {
      console.error("Error fetching courses:", error);
    }
  };

  showModal = async() => {
    await this.fetchCourses();
    this.setState({ 
      visible: true,
      selectedCourses: [{ course: null, maxUsers: "" }],
    });
  };

  handleCancel = () => {
    this.setState({
      visible: false,
      selectedCourses: [{ course: null, maxUsers: "" }],
    });
  };

  handleSubmit = async () => {
    const { selectedCourses } = this.state;
    const { authToken, groupId } = this.props;

    if (selectedCourses.every((item) => item.course && item.maxUsers)) {
      try {
        const payload = {
          group_id: groupId,
          courses: this.state.selectedCourses.map((item) => ({
            course_id: item.course,
            max_user_count: Number(item.maxUsers),
          })),
        };        

        console.log("Submitting:", payload);

        const response = await AssignGroupCourse(authToken, payload);
        console.log("Response:", response);

        if (response && response.status === 200) {
          notification.success({
            message: "Success",
            description: "Courses assigned successfully!",
          });
          this.setState({ visible: false });
          window.location.reload();
        } else if (response) {
          notification.error({
            message: "Error",
            description: response.message || "Failed to assign courses.",
          });
        }
      } catch (error) {
        console.error("Error submitting courses:", error);
        notification.error({
          message: "Error",
          description: "Failed to assign courses. Please try again.",
        });
      }
    } else {
      alert("Please fill all fields.");
    }
  };

  handleChange = (index, field, value) => {
    const selectedCourses = [...this.state.selectedCourses];
    selectedCourses[index][field] = value;
    this.setState({ selectedCourses });
  };

  addRow = () => {
    const { selectedCourses } = this.state;
    if (selectedCourses.length < 5) {
      this.setState({
        selectedCourses: [...selectedCourses, { course: null, maxUsers: "" }],
      });
    } else {
      alert("You can add a maximum of 5 courses.");
    }
  };

  removeRow = (index) => {
    const selectedCourses = [...this.state.selectedCourses];
    selectedCourses.splice(index, 1);
    this.setState({ selectedCourses });
  };

  renderRows = () => {
    const { selectedCourses, courses } = this.state;

    let rows = [];
    for (let i = 0; i < selectedCourses.length; i++) {
      rows.push(
        <div
          key={i}
          style={{ display: "flex", gap: "15px", alignItems: "flex-end", marginBottom: "15px" }}
        >
          {/* Course Dropdown */}
          <div style={{ flex: 2.5 }}>
            <div style={{ marginBottom: "5px", fontWeight: "600", fontSize: "13px", color: "#555" }}>Courses</div>
            <CustomSelect
              id={`course_${i}`}
              placeholder="Select Course"
              value={selectedCourses[i].course}
              onChange={(value) => this.handleChange(i, "course", value)}
              style={{ width: "100%" }}
              showSearch={true}
              options={courses.map((c) => ({ value: c._id, label: c.name }))}
            />
          </div>

          {/* Max Users */}
          <div style={{ flex: 1 }}>
            <div style={{ marginBottom: "5px", fontWeight: "600", fontSize: "13px", color: "#555" }}>Max Users</div>
            <Input
              type="number"
              min="0"
              placeholder="Max Users"
              value={selectedCourses[i].maxUsers || ""}
              onChange={(e) => {
                let value = Math.max(0, Number(e.target.value));
                
                if (value < 1) {
                  notification.error({
                    message: "Invalid Input",
                    description: "Value less than 1 is not allowed.",
                  });
                }
          
                this.handleChange(i, "maxUsers", value);
              }}
              style={{ width: "100%", height: "38px" }}
            />
          </div>

          {/* Remove Row Button */}
          <Button
            danger
            type="text"
            icon={<DeleteOutlined />}
            onClick={() => this.removeRow(i)}
            disabled={selectedCourses.length === 1}
            style={{
              width: "38px",
              height: "38px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          />
        </div>
      );
    }
    return rows;
  };

  render() {
    const { visible, selectedCourses } = this.state;

    return (
      <>
        {/* Assign Button */}
        <Button type="primary" onClick={this.showModal}>
          Assign Course
        </Button>

        {/* Modal */}
        <CustomModal
          title="Assign Course"
          visible={visible}
          onCancel={this.handleCancel}
          width="600px"
          maskClosable={false}
          bodyStyle={{ paddingBottom: "20px" }}
        >
          <div style={{ display: "flex", flexDirection: "column", minHeight: "220px", justifyContent: "space-between" }}>
            <div>
              {this.renderRows()}
            </div>

            {/* Modal Footer with Actions */}
            <div style={{ 
              display: "flex", 
              justifyContent: "space-between", 
              alignItems: "center", 
              marginTop: "20px", 
              paddingTop: "15px", 
              borderTop: "1px solid #f0f0f0" 
            }}>
              <div>
                {selectedCourses.length < 5 && (
                  <Button
                    type="dashed"
                    icon={<PlusOutlined />}
                    onClick={this.addRow}
                  >
                    Add Course
                  </Button>
                )}
              </div>
              <div style={{ display: "flex", gap: "10px" }}>
                <Button onClick={this.handleCancel}>
                  Cancel
                </Button>
                <Button type="primary" onClick={this.handleSubmit}>
                  Assign
                </Button>
              </div>
            </div>
          </div>
        </CustomModal>
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  authToken: state.auth.authToken,
  LoginData: state.auth.loginUserData,
});

export default connect(mapStateToProps)(withRouter(AssignCourse));
